import { render, staticRenderFns } from "./PpsGroupList.vue?vue&type=template&id=0e89105c&scoped=true&"
import script from "./PpsGroupList.vue?vue&type=script&lang=js&"
export * from "./PpsGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e89105c",
  null
  
)

export default component.exports